import AppBackLink from './BackLink';

export default AppBackLink;
